// extracted by mini-css-extract-plugin
export var teleformContainer = "teleformulaire-module--teleform-container--8cbd6";
export var teleformFooter = "teleformulaire-module--teleform-footer--d5f89";
export var teleformLibre = "teleformulaire-module--teleform-libre--f31d3";
export var teleformLinks = "teleformulaire-module--teleform-links--a0287";
export var teleformLinksItem = "teleformulaire-module--teleform-links-item--c8292";
export var teleformLinksItemTitle = "teleformulaire-module--teleform-links-item-title--365d8";
export var teleformLinksList = "teleformulaire-module--teleform-links-list--1cd5a";
export var teleformLinksTitle = "teleformulaire-module--teleform-links-title--b4754";
export var teleformTaxo = "teleformulaire-module--teleform-taxo--eda10";
export var teleformTaxoItem = "teleformulaire-module--teleform-taxo-item--3c9b0";
export var teleformTitle = "teleformulaire-module--teleform-title--63690";
export var teleformulaire = "teleformulaire-module--teleformulaire--129b4";